import { FC } from 'react'
import Script from 'next/script'

interface TrustPilotScriptProps {
  activate: boolean
  onError?: () => void
}

const TrustPilotScript: FC<TrustPilotScriptProps> = ({ activate, onError }) => {
  if (!activate) {
    return null
  }

  return (
    <Script
      data-testid="trustpilot-script"
      src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
      onError={onError}
    />
  )
}

export default TrustPilotScript
